import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./dashboard";
import Customers from "./customers";
import ProtectedRoute from "../../../components/util-components/ProtectedRoute";
import Products from "./products";
import SooCoolDeliveries from "./deliveries";
import Complaints from "./complaints";
import Stock from "./stock";
import ProductsAvailabilityPage from "./products/products-availability";

const PARENT_URL = "/cms/reports";

const Reports = () => {
  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <ProtectedRoute routeKey={"shop-reports"}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/customers`}
        element={
          <ProtectedRoute routeKey={"shop-reports-customers"}>
            <Customers />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/products`}
        element={
          <ProtectedRoute routeKey={"shop-reports-products"}>
            <Products />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/deliveries/soocool`}
        element={
          <ProtectedRoute routeKey={"shop-reports-deliveries"}>
            <SooCoolDeliveries />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/complaints`}
        element={
          <ProtectedRoute routeKey={"shop-reports-complaints"}>
            <Complaints />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/stock`}
        element={
          <ProtectedRoute routeKey={"shop-reports-stock"}>
            <Stock />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/products/availability`}
        element={
          <ProtectedRoute routeKey={"shop-reports-products"}>
            <ProductsAvailabilityPage />
          </ProtectedRoute>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/`} replace />} />
    </Routes>
  );
};

export default Reports;
